module.exports = __webpack_public_path__ + "img/hykzsxny_s.d4242b1.png";